import {decorate, observable} from 'mobx';
import {BaseModel} from './base';

export class BatchQueueItem extends BaseModel {
  populateAttributesFromStore(rootStore) {
    this.batch = rootStore.batchStore.getById(this.batchId);
    return super.populateAttributesFromStore(rootStore);
  }
}

decorate(BatchQueueItem, {
  id: observable,
  workplaceId: observable,
  materialId: observable,
  quantity: observable,
  quantityUsed: observable,
  updatedAt: observable,
  createdAt: observable,
  plannedAt: observable,
  batchId: observable,
  batch: observable,
  state: observable,
});

export const BatchQueueItemState = Object.freeze({
  used: 'USED',
  cancelled: 'CANCELLED',
  active: 'ACTIVE',
  planned: 'PLANNED',
});
